module.exports = __webpack_public_path__ + "static/media/izlozba (9).b4c49c0a.jpg";